import React from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import BlogItem from './components/BlogItem'

const BlogList = ({ data, wrapper }) => (
  <div className="blog-list">
    {wrapper && <h3 className="read-more">Lue myös nämä</h3>}
    {wrapper
      ? data.map(item => (
          <BlogItem
            key={item.title}
            title={item.title}
            date={item.date}
            link={item.link}
            wrapper
          />
        ))
      : data.map(item => (
          <BlogItem
            media={item.media}
            key={item.title}
            title={item.title}
            date={item.date}
            link={item.link}
          />
        ))}
    {wrapper && (
      <Link to="/blogi" className="see-all">
        Katso kaikki
      </Link>
    )}
  </div>
)

export default BlogList

BlogList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  wrapper: PropTypes.bool,
}

BlogList.defaultProps = {
  wrapper: false,
}
